import React, {useEffect, useState} from 'react'
import {useRequest} from "ahooks";
import {FormSelect} from "../../../../components/Custom/Form/FormSelect";
import {useFormikContext} from "formik";
import templateService from "../../../../services/templateService";
import TemplateOffCanvas from "./TemplateOffCanvas";
import CanvasCreateEditButtons from "../../../../components/Custom/UI/Canvas/CanvasCreateEditButtons";
import {toast} from "react-toastify";

const TemplatePicker = ({name, type, onSelected, withCreate}) => {

    const {data, loading, runAsync} = useRequest(templateService.selectable, {
        defaultParams: [type]
    });

    const [currentSelected, setCurrentSelected] = useState(undefined);
    const {values, setFieldValue} = useFormikContext()
    const [isCanvasOpen, setIsCanvasOpen] = useState(false);

    useEffect(() => {
        if (loading)
            return;

        if (values[name]) {
            const option = data.find(d => d.value === values[name])
            option
                ? templateService.fetch(option.uuid).then(res => setCurrentSelected(res))
                : setCurrentSelected(undefined)
        } else {
            setCurrentSelected(undefined)
        }

    }, [data, values[name]])

    const handleResponse = (value) => {
        runAsync({type: type}).then(() => {
            onSelected({
                value: value.id,
                label: value.name
            })
            setIsCanvasOpen(false)
        })
    }

    const handleDelete = () => {
        templateService.destroy(currentSelected.uuid)
            .then(res => runAsync()
                .then(() => {
                    setFieldValue(name, undefined)
                    toast.success('Operazione eseguita con successo')
                })
            ).catch(err => toast.error(err.response.data.message))
    }

    useEffect(() => {
        setCurrentSelected((data || []).find(d => d.value === values[name]))
    }, [values[name]]);

    return (
        <React.Fragment>
            <FormSelect
                name={name}
                onChange={(template) => onSelected(data.find(d => d.value === template))}
                loading={loading}
                placeholder="Seleziona una dima/telaio"
                options={data}
                multiple={false}
            />

            {withCreate &&
                <>
                    <CanvasCreateEditButtons
                        value={values[name]}
                        canvasOpen={isCanvasOpen}
                        setCanvasOpen={setIsCanvasOpen}
                        handleDelete={handleDelete}
                    />

                    <TemplateOffCanvas
                        isOpen={isCanvasOpen}
                        toggle={setIsCanvasOpen}
                        data={currentSelected}
                        handleResponse={handleResponse}
                    />
                </>
            }


        </React.Fragment>
    )
}

export default TemplatePicker
